interface ICreateInvestmentApartmentsAmplitudeItemListIdParams {
    offerId: number;
    backendQueryId?: string | null;
    now?: number;
}

export const createInvestmentApartmentsAmplitudeItemListId = ({
    offerId,
    backendQueryId,
    now = Date.now()
}: ICreateInvestmentApartmentsAmplitudeItemListIdParams): string => {
    const timestamp = Math.floor(now / 1000);

    return backendQueryId ? `${timestamp}_${backendQueryId}` : `${timestamp}_investment_apartments_${offerId}`;
};

interface IGetInvestmentApartmentsAmplitudeRequestKeyParams {
    offerId: number;
    page?: number | null;
    sort?: number | string | null;
    filters?: Record<string, unknown> | null;
}

export const getInvestmentApartmentsAmplitudeRequestKey = ({offerId, page, sort, filters}: IGetInvestmentApartmentsAmplitudeRequestKeyParams): string =>
    [`offer:${offerId}`, `page:${page ?? 1}`, `sort:${sort ?? ""}`, `filters:${stableStringify(filters ?? {})}`].join("|");

const stableStringify = (value: Record<string, unknown>): string =>
    JSON.stringify(
        Object.keys(value)
            .sort()
            .reduce<Record<string, unknown>>((accumulator, key) => {
                if (value[key] !== undefined && value[key] !== null && value[key] !== "") {
                    accumulator[key] = value[key];
                }

                return accumulator;
            }, {})
    );
interface ICreateInvestmentApartmentsAmplitudeItemListIdParams {
    offerId: number;
    backendQueryId?: string | null;
    now?: number;
}

export const createInvestmentApartmentsAmplitudeItemListId = ({
    offerId,
    backendQueryId,
    now = Date.now()
}: ICreateInvestmentApartmentsAmplitudeItemListIdParams): string => {
    const timestamp = Math.floor(now / 1000);

    return backendQueryId ? `${timestamp}_${backendQueryId}` : `${timestamp}_investment_apartments_${offerId}`;
};

interface IGetInvestmentApartmentsAmplitudeRequestKeyParams {
    offerId: number;
    page?: number | null;
    sort?: number | string | null;
    filters?: Record<string, unknown> | null;
}

export const getInvestmentApartmentsAmplitudeRequestKey = ({offerId, page, sort, filters}: IGetInvestmentApartmentsAmplitudeRequestKeyParams): string =>
    [`offer:${offerId}`, `page:${page ?? 1}`, `sort:${sort ?? ""}`, `filters:${stableStringify(filters ?? {})}`].join("|");

const stableStringify = (value: Record<string, unknown>): string =>
    JSON.stringify(
        Object.keys(value)
            .sort()
            .reduce<Record<string, unknown>>((accumulator, key) => {
                if (value[key] !== undefined && value[key] !== null && value[key] !== "") {
                    accumulator[key] = value[key];
                }

                return accumulator;
            }, {})
    );
